import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const getScrollTargets = () => {
  const targets = [];
  const contentWrapper = document.querySelector('.content-wrapper');
  if (contentWrapper) {
    targets.push(contentWrapper);
  }
  const contentSection = document.querySelector('.content');
  if (contentSection) {
    targets.push(contentSection);
  }
  targets.push(document.documentElement);
  targets.push(document.body);
  targets.push(window);
  return targets;
};

const setScrollTop = (target, top) => {
  if (target === window) {
    window.scrollTo(0, top);
  } else if (target && typeof target.scrollTop === 'number') {
    target.scrollTop = top;
  }
};

const ScrollRestoration = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    const targets = getScrollTargets();
    targets.forEach((target) => setScrollTop(target, 0));
    requestAnimationFrame(() => {
      targets.forEach((target) => setScrollTop(target, 0));
    });
    setTimeout(() => {
      targets.forEach((target) => setScrollTop(target, 0));
    }, 0);
  }, [location.pathname, location.search]);

  return null;
};

export default ScrollRestoration;
